import { Container, Typography } from '@mui/material'
import useStyles from '../styles/styles'
import Reveal from './Reveal'

const socials = [
  { id: 1, label: 'LinkedIn', icon: 'fa-brands fa-linkedin-in', link: 'https://www.linkedin.com/in/mahadi-sheriff' },
  { id: 2, label: 'X', icon: 'fa-brands fa-twitter', link: 'https://www.twitter.com/TheOltaEgo' },
  { id: 3, label: 'GitHub', icon: 'fa-brands fa-github', link: 'https://github.com/sheriifMahadi' },
]

const Contact = () => {
  const classes = useStyles()
  return (
    <section id="contact" className={`${classes.section} ${classes.alternateSection}`}>
      <Container className={classes.content}>
        <Reveal>
          <div className={classes.contactPanel}>
            <Typography className={classes.eyebrow}>03 / Contact</Typography>
            <Typography component="h2" className={classes.sectionTitle}>Let’s build something worthwhile.</Typography>
            <Typography className={classes.bodyCopy} style={{ margin: '24px auto 0' }}>
              I’m open to new opportunities and interesting collaborations. Find me on any of the platforms below.
            </Typography>
            <ul className={classes.socialList}>
              {socials.map((social) => (
                <li key={social.id} className={classes.listStyling}>
                  <a href={social.link} target="_blank" rel="noreferrer" aria-label={social.label} className={classes.linkStyling}><i className={social.icon} /></a>
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
      </Container>
    </section>
  )
}

export default Contact
